import { render, staticRenderFns } from "./JWPlayer.vue?vue&type=template&id=6ebc0d02&scoped=true&"
import script from "./JWPlayer.vue?vue&type=script&lang=js&"
export * from "./JWPlayer.vue?vue&type=script&lang=js&"
import style0 from "./JWPlayer.vue?vue&type=style&index=0&id=6ebc0d02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc0d02",
  null
  
)

export default component.exports